var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookButtonLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_190)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.345947 0.537109)",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8459 12.607C23.8459 6.25571 18.6972 1.10699 12.3459 1.10699C5.99467 1.10699 0.845947 6.25571 0.845947 12.607C0.845947 18.347 5.05133 23.1046 10.5491 23.9673V15.9312H7.62915V12.607H10.5491V10.0734C10.5491 7.19121 12.2659 5.59918 14.8928 5.59918C16.151 5.59918 17.467 5.82379 17.467 5.82379V8.65386H16.0169C14.5883 8.65386 14.1428 9.54033 14.1428 10.4498V12.607H17.3323L16.8224 15.9312H14.1428V23.9673C19.6406 23.1046 23.8459 18.347 23.8459 12.607Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.345947 0.537109)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookButtonLogo);
export default __webpack_public_path__ + "static/media/facebook_button_logo.608910ff12f759f104cfe25dfdae612b.svg";
export { ForwardRef as ReactComponent };